var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { ColorPicker as BaseColorPicker, colorToHex as baseColorToHex, colorToHexString as baseColorToHexString, colorToHsl as baseColorToHsl, colorToHslString as baseColorToHslString, colorToHsv as baseColorToHsv, colorToPercentage as baseColorToPercentage, colorToRgb as baseColorToRgb, colorToRgbString as baseColorToRgbString, } from "@vividtheory/minerva-lab";
import React from "react";
export const colorToHsv = baseColorToHsv;
export const colorToHsl = baseColorToHsl;
export const colorToRgb = baseColorToRgb;
export const colorToHex = baseColorToHex;
export const colorToRgbString = baseColorToRgbString;
export const colorToHslString = baseColorToHslString;
export const colorToHexString = baseColorToHexString;
export const colorToPercentage = baseColorToPercentage;
export const ColorPicker = (_a) => {
    var { onSaveAsDefault, onApply = onSaveAsDefault, hideApplyButton = onApply === undefined, applyButtonText = "Apply", slotProps } = _a, props = __rest(_a, ["onSaveAsDefault", "onApply", "hideApplyButton", "applyButtonText", "slotProps"]);
    return (React.createElement(BaseColorPicker, Object.assign({ onApply: onApply, hideApplyButton: hideApplyButton, applyButtonText: onSaveAsDefault ? "Save as default" : applyButtonText, slotProps: Object.assign({ styledPointer: {
                style: {
                    boxSizing: "content-box",
                },
            } }, slotProps) }, props)));
};
//# sourceMappingURL=ColorPicker.js.map